export enum ProductCategory {
    General = 'general',
    RealEstate = 'realEstate'
}
